import * as React from "react";
const LoaderIcon = ({
  size = 24,
  title = "LoaderIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pds-icon", title, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.895 12c0 5.581 4.524 10.105 10.105 10.105S22.105 17.581 22.105 12 17.581 1.895 12 1.895", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
export default LoaderIcon;
